import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'precoVenda',
    standalone: false,
})

export class PrecoVendaPipe implements PipeTransform {

  transform(custo: number): any {

    return (custo * 0.075).toFixed(2);
    //return Math.round(custo/24)+1;

  }

}
